export const administrationAccountsDepartments = {
    template: require('./administration-accounts-departments.html'),
    controller: 'AdministrationAccountsDepartmentsController'
};
